<script setup>
import { ref, reactive, onMounted, defineEmits } from 'vue'
import { helpers, required } from '@vuelidate/validators'
import { useToast } from 'primevue/usetoast'
import dayjs from 'dayjs'
import errorHandler from '@/helpers/errorhandler'
import FxReportContainer from '@/components/FxReportContainer'
import LaporanPiutangUsahaService from '@/services/LaporanPiutangUsahaService'
import PelangganService from '@/services/PelangganService'
import useVuelidate from '@vuelidate/core'
import { saveAs } from 'file-saver'

const toast = useToast()
const laporanService = new LaporanPiutangUsahaService()
const pelangganService = new PelangganService()
let dialogViewer = ref(false)
let pdfSource = ref('')
let pdfTitle = ref('PDF Viewer')
let pdfFilename = ref('')

let isLoadingExport = ref(false)
let isLoadingExportExcel = ref(false)
let form = reactive({
  date_from: null,
  date_to: null,
  pelanggan: null,
  type: 'pajak',
})
let submitted = ref(false)
let acPelanggan = ref([])

const rules = {
  /*
  pelanggan: {
    required: helpers.withMessage('Pelanggan harus diisi.', required),
  },
  */
  date_from: {
    required: helpers.withMessage('Tanggal harus diisi.', required),
  },
  date_to: {
    required: helpers.withMessage('Tanggal harus diisi.', required),
  },
}

const v$ = useVuelidate(rules, form)

// eslint-disable-next-line no-unused-vars
const emit = defineEmits(['toggle'])

onMounted(async () => {
  /*
  const res = await pelangganService.get('?sort=nama')
  list_pelanggan.value = res.data.data
  */
})

function searchPelanggan(e) {
  pelangganService
    .get(`?filter[nama]=${e.query}`)
    .then((res) => {
      acPelanggan.value = res.data.data
    })
    .catch((err) => {
      errorHandler(err, 'Data Pelanggan', toast)
    })
}

function search(isFormValid) {
  submitted.value = true

  if (!isFormValid) {
    return
  }

  onExport()
}

/*
function onRequestData(isFormValid) {
  const startDate = dayjs(form.date_from).format('YYYY-MM-DD')
  const endDate = dayjs(form.date_to).format('YYYY-MM-DD')
  const pelangganId = form.pelanggan
  const type = form.type

  submitted.value = true

  if (!isFormValid) {
    return
  }

  isLoading.value = true
  laporanService
    .getLaporanPembayaranPerPelanggan(startDate, endDate, pelangganId, type)
    .then((res) => {
      items = res.data.data
      isLoading.value = false
    })
    .catch((err) => {
      errorHandler(err, 'Data Pembayaran Piutang Per Pelanggan', toast)
    })
    .finally(() => (isLoading.value = false))
}
*/

function onExport() {
  isLoadingExport.value = true
  const startDate = dayjs(form.date_from).format('YYYY-MM-DD')
  const endDate = dayjs(form.date_to).format('YYYY-MM-DD')

  const type = form.type

  let pelangganId = null
  if (form.pelanggan) {
    pelangganId = form.pelanggan.id
  }

  laporanService
    .exportLaporanPembayaranPerPelanggan(startDate, endDate, pelangganId, type)
    .then((res) => {
      const blob = new Blob([res.data], { type: 'application/pdf' })
      const pdfUrl = URL.createObjectURL(blob)
      pdfSource.value = pdfUrl + '#toolbar=0'
      pdfFilename.value = 'laporan-pembayaran-piutang-per-pelanggan.pdf'
      pdfTitle.value = 'PDF Viewer (' + pdfFilename.value + ')'
      dialogViewer.value = true
    })

    .catch((err) => {
      errorHandler(err, 'Data Laporan Pembayaran Piutang Per Pelanggan', toast)
    })
    .finally(() => (isLoadingExport.value = false))
}

function onExportExcel(isFormValid) {
  submitted.value = true

  if (!isFormValid) {
    return
  }

  isLoadingExportExcel.value = true
  const startDate = dayjs(form.date_from).format('YYYY-MM-DD')
  const endDate = dayjs(form.date_to).format('YYYY-MM-DD')

  const type = form.type

  let pelangganId = null
  if (form.pelanggan) {
    pelangganId = form.pelanggan.id
  }

  laporanService
    .exportExcelLaporanPembayaranPerPelanggan(
      startDate,
      endDate,
      pelangganId,
      type
    )
    .then((res) => {
      isLoadingExportExcel.value = false
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        'laporan-pembayaran-piutang-per-pelanggan.xls'
      )
      document.body.appendChild(link)
      link.click()
    })

    .catch((err) => {
      errorHandler(err, 'Data Laporan Pembayaran Piutang Per Pelanggan', toast)
    })
    .finally(() => (isLoadingExportExcel.value = false))
}

function onPrintPdf() {
  const iframe = document.createElement('iframe')
  iframe.src = pdfSource.value
  iframe.style.display = 'none'
  document.body.appendChild(iframe)

  // Use onload to make pdf preview work on firefox
  iframe.onload = () => {
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
  }
}

function onDownloadPdf() {
  saveAs(pdfSource.value, pdfFilename.value)
}

function onToggle() {
  emit('toggle')
}

function resetForm() {
  form.date_form = null
  form.date_to = null
  form.pelanggan = null
  form.type = null
}
</script>

<template>
  <fx-report-container
    title="Laporan Pembayaran Piutang Per Pelanggan"
    :loading="isLoadingExport"
    @toggle="onToggle"
    @export="onExport"
  >
    <template #content>
      <form @submit.prevent="search(!v$.$invalid)">
        <div class="formgrid grid">
          <div class="field col-12">
            <div class="font-bold">Filter</div>
          </div>
          <div class="field col-12 md:col-6">
            <!--
            <Dropdown
              v-model="form.pelanggan"
              :options="list_pelanggan"
              optionValue="id"
              optionLabel="nama"
              placeholder="Pilih Pelanggan"
              class="w-full"
              filter
              showClear
            />
            -->
            <AutoComplete
              v-model="form.pelanggan"
              :min-length="2"
              :suggestions="acPelanggan"
              field="nama"
              class="w-full"
              input-class="w-full"
              placeholder="Pelanggan"
              autofocus
              @complete="searchPelanggan($event)"
            >
              <template #item="slotProps">
                <div>
                  <strong
                    >{{ slotProps.item.kode }} -
                    {{ slotProps.item.nama }}</strong
                  >
                </div>
                <div>Alamat: {{ slotProps.item.alamat }}</div>
                <div>Salesman: {{ slotProps.item.salesman.nama }}</div>
              </template>
            </AutoComplete>
          </div>
          <div class="field col-12 md:col-3">
            <Calendar
              v-model="v$.date_from.$model"
              dateFormat="dd/mm/yy"
              :class="{
                'p-invalid': v$.date_from.$invalid && submitted,
              }"
              placeholder="Tanggal (dari)"
              class="w-full"
            />
            <small
              v-if="
                (v$.date_from.$invalid && submitted) ||
                v$.date_from.$pending.$response
              "
              class="p-error"
              >{{ v$.date_from.required.$message }}</small
            >
          </div>
          <div class="field col-12 md:col-3">
            <Calendar
              v-model="v$.date_to.$model"
              dateFormat="dd/mm/yy"
              :class="{
                'p-invalid': v$.date_to.$invalid && submitted,
              }"
              placeholder="Tanggal (s/d)"
              class="w-full"
            />
            <small
              v-if="
                (v$.date_to.$invalid && submitted) ||
                v$.date_to.$pending.$response
              "
              class="p-error"
              >{{ v$.date_to.required.$message }}</small
            >
          </div>
          <div class="field col-12 md:col-6">
            <div class="formgroup-inline">
              <div class="field-radiobutton">
                <RadioButton name="Pajak" value="pajak" v-model="form.type" />
                <label>Pajak</label>
              </div>
              <div class="field-radiobutton">
                <RadioButton name="Intern" value="intern" v-model="form.type" />
                <label>Intern</label>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <Button
              :loading="isLoadingExport"
              type="submit"
              icon="pi pi-file-pdf"
              label="Cetak"
              class="mr-2"
            />
            <Button
              :loading="isLoadingExportExcel"
              type="button"
              icon="pi pi-file-excel"
              label="Export"
              class="p-button-success mr-2"
              @click="onExportExcel(!v$.$invalid)"
            />
            <Button
              type="reset"
              icon="pi pi-refresh"
              label="Reset"
              class="p-button-outlined md:mt-2 lg:mt-0"
              @click="resetForm"
            />
          </div>
        </div>
      </form>
    </template>
  </fx-report-container>
  <Dialog
    :header="pdfTitle"
    v-model:visible="dialogViewer"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '90vw' }"
    :modal="true"
  >
    <div>
      <embed
        :src="pdfSource"
        type="application/pdf"
        width="100%"
        height="600px"
      />
    </div>
    <template #footer>
      <Button
        type="button"
        label="Download"
        icon="pi pi-download"
        class="p-button-text mr-2"
        @click="onDownloadPdf"
      />
      <Button
        type="button"
        label="Print"
        icon="pi pi-print"
        @click="onPrintPdf"
      />
    </template>
  </Dialog>
</template>
